// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"97":"asset","183":"snapshot","962":"home"}[chunkId] + "." + {"97":"3510b543","183":"49173cae","962":"2f7c17a4"}[chunkId] + ".css";
};